import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInitialize } from '../actions/action_auth';
import Loadingpage from '../pages/loadingpage';
import { useLocation, useNavigate } from 'react-router-dom';
// import { useLocation, useNavigate } from 'react-router';

export default function JwtProvider({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isSocialRoute = location.pathname.includes('social');
  const { loading, errors } = useSelector(state => state.user);
  const analyticsLoaded = useRef(false);

  useEffect(() => {
    // console.log("jwt provider")
    if (!isSocialRoute) {
      dispatch(getInitialize());
    }
  }, [isSocialRoute]);

  function loadAnalytics() {
  // Google Tag Manager
  const gtm = document.createElement("script");
  gtm.src = "https://www.googletagmanager.com/gtm.js?id=GTM-WT4RPQW4";
  gtm.async = true;
  document.head.appendChild(gtm);

  // Google Analytics
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }
  gtag("js", new Date());
  gtag("config", "G-J5MV81T9KM");

  // Hotjar
  const hj = document.createElement("script");
  hj.src = "https://static.hotjar.com/c/hotjar-5018528.js?sv=6";
  hj.async = true;
  document.head.appendChild(hj);
}


  useEffect(() => {
    if (!loading && localStorage.getItem("accessToken") && !analyticsLoaded.current) {
      analyticsLoaded.current = true;
      loadAnalytics();
    }
  }, [loading]);

  useEffect(() => {
    dispatch({ type: "SET_DEFAULT_CURRENCY" });
  }, [dispatch]);
  // if(loading && !isSocialRoute) return <Loadingpage />
  if (loading && !isSocialRoute) return <div className="loader"></div>;
  // if(errors) return navigate('/signin')
  return <>{children}</>;
}
